(function () {
    angular.module('core')
      .service('dblLessonService', [
          '$window',
          'edxLessonSlotsApi',
          'translateFilter',
          'localeService',
          'lessonConstants',
          DblLessonService
      ]);

    function DblLessonService(
      $window,
      lessonSlotsApi,
      translateFilter,
      localeService,
      lessonConstants
    ) {
        var _lessonRootUrl = lessonConstants.LESSON_ROOT_URL;

        // TODO:  use 'this' instead of separate service object.
        var service = {
            ASSIGNED: 'reports.assigned',
            LESSON_PLAY_COUNTS: {
                1: 'reports.times.first',
                2: 'reports.times.second',
                3: 'reports.times.third',
                4: 'reports.times.fourth',
                5: 'reports.times.fivePlus'
            },
            LESSON_STATUS: {
                COMPLETED: 'lessons.lessonCompleted',
                PAUSED: 'lessons.lessonPaused',
            },
            LESSON_UNDERSTANDING: {
                NO: 'lessons.noDemonstratedUnderstanding',
                STRUGGLING: 'lessons.mayBeStruggling',
                YES: 'lessons.demonstratedUnderstanding',
            }
        };

        var cachedTranslations = {};

        function getCompletedInstanceCountString(lessonCompletedInstanceCount) {
            lessonCompletedInstanceCount = Math.min(lessonCompletedInstanceCount, 5);
            var countKey = service.LESSON_PLAY_COUNTS[lessonCompletedInstanceCount];

            if (countKey) {
                if (!cachedTranslations[countKey]) {
                    cachedTranslations[countKey] = translateFilter(countKey);
                }
                return cachedTranslations[countKey];
            }

            throw new Error('Completed instance count must be a positive integer.');
        }

        function getDemoButtonText(hasDemo, isForLesson) {
            if (!hasDemo) {
                return translateFilter('reports.noDemo');
            }

            return translateFilter('reports.' + (isForLesson ? 'playLesson' : 'playDemo'));
        }

        function getDemoLink(lessonSlotName) {
            var lcid = localeService.getLcidFromCurrentLocale();
            var url = lessonConstants.getDemoLink(lessonSlotName, 'Intermediate', lcid, '');

            // Replace constants URL with potentially overridden URL to preserve setLessonRootUrl() functionality
            return url.replace(lessonConstants.LESSON_ROOT_URL, _lessonRootUrl);
        }

        function getImageForDblStandard(dblStandardName) {
            if (!dblStandardName) {
                // TODO: use a default image here
                return '';
            }

            return '/resources/images/dbl_standard_icon/dbla_' + dblStandardName.toLowerCase() + '.png';
        }

        function _openDemoLink(lessonSlotName) {
            $window.open(getDemoLink(lessonSlotName), '_blank');
        }

        /**
         * Opens a lesson in Dreambox client in demo mode
         *
         * Opens a new tab with the Dreambox client.  The client will play the given lesson in demo mode.
         *
         * @param lessonSlotId ID of lesson to play
         */
        function openPlayLessonLink(lessonSlotId) {
            lessonSlotsApi.get({lesson_slot_id: lessonSlotId}).then(function(lessonSlot){
                _openDemoLink(lessonSlot.name);
            });
        }

        // This should be called early when the app is loading to override the default of play.dreambox.com
        // Ideally this service would be a provider, or use a promise to guarantee
        // to any caller of getDemoLink that the lesson root url was updated in time.  In practice,
        // this doens't seem necessary with the current usages.
        function setLessonRootUrl(lessonRootUrl) {
            _lessonRootUrl = lessonRootUrl;
        }

        service.getCompletedInstanceCountString = getCompletedInstanceCountString;
        service.getDemoButtonText = getDemoButtonText;
        service.getDemoLink = getDemoLink;
        service.getImageForDblStandard = getImageForDblStandard;
        service.openPlayLessonLink = openPlayLessonLink;
        service.setLessonRootUrl = setLessonRootUrl;

        return service;
    }
})();
